import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import Constants from '../Constants';
import '../App.css';

function BetaTestView() {
	const [email, set_email] = useState('');
	const [loading, set_loading] = useState(false);
	const [error, set_error] = useState('');
	const [success, set_success] = useState('');

	const handle_submit = async (event) => {
		event.preventDefault();
		set_error('');
		set_success('');

		if(!email.trim()) {
			set_error('Please enter an email address.');
			return;
		}

		set_loading(true);
		try {
			await axios.post(Constants.SERVER_URL + '/api/email_list_signup', { email });
			set_success('You are on the list! We will be in touch.');
			set_email('');
		} catch (err) {
			const msg = err.response && err.response.data && err.response.data.message;
			set_error(msg || 'Something went wrong. Please try again.');
		} finally {
			set_loading(false);
		}
	};

	return (
		<React.Fragment>
			<main className="admin-main">
				<h4 className="admin-title">Join the Beta</h4>
				<p className="admin-description">Enter your email to get early access to AI Call Trainer.</p>

				{error ? <Alert variant="danger">{error}</Alert> : null}
				{success ? <Alert variant="success">{success}</Alert> : null}

				<Form onSubmit={handle_submit} className="admin-form-panel">
					<Form.Group className="admin-form-group">
						<Form.Label className="form-input-label">Email</Form.Label>
						<Form.Control
							type="email"
							value={email}
							onChange={function(e) { set_email(e.target.value); }}
							placeholder="your@email.com"
							className="admin-form-control"
						/>
					</Form.Group>

					<div className="admin-form-actions">
						<Button variant="primary" type="submit" disabled={loading}>
							{loading ? <Spinner animation="border" size="sm" /> : 'Get Early Access'}
						</Button>
					</div>
				</Form>
			</main>
		</React.Fragment>
	);
}

export default BetaTestView;
